import { createApp, defineComponent } from 'vue';
import GridEstimationCellEditor from './GridEstimationCellEditor.vue';
import timeParser from '$$helpers/timeParser';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridEstimationCellEditor);

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder);
      vueInstance = vueApp.mount(placeholder);
    },
    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;
      vueInstance = null;
    },

    set_value(task, id, column, node) {
      const durationData = instance.config.durationData

      vueInstance.value = timeParser.output(task.estimation, {
        durationData,
        durationStep: instance.config.duration_view,
        prop: 'estimation',
      });
    },

    get_value(id, column, node) {
      return vueInstance.value;
    },

    is_changed(task, id, column, node) {
      return true;
    },

    is_valid(value, id, column, node) {
      return true;
    },

    save(id, column, node) {
      const task = instance.getTask(id);
      const durationData = instance.config.durationData;

      const parserResult = timeParser.input(vueInstance.value, {
        durationData,
        prop: 'estimation',
      });

      if (!parserResult) {
        return;
      }

      const value = +parserResult.value || 0;

      if (value >= 0 && value !== task.estimation) {
        task.estimation = value;
        instance.updateTask(task.id);

        userExtAnalytics.log('task_grid_action', { action: 'estimation' });
      }
    },

    focus(node) {
    },
  };
}
